"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _fileSizeHelper = require("@eig-builder/core-utils/helpers/file-size-helper");

var _signedUrlHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/signed-url-helper"));

var _storeServiceUrlHelper = require("@eig-builder/core-utils/helpers/store-service-url-helper");

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _Button = _interopRequireDefault(require("@eig-builder/core-ui/Button"));

var _CircularProgress = _interopRequireDefault(require("@eig-builder/core-ui/CircularProgress"));

var _config = require("../config");

var _uploadProgress = _interopRequireDefault(require("../controls/upload-progress"));

var _imageCanvas = _interopRequireDefault(require("../controls/image-canvas"));

var _withContext = _interopRequireDefault(require("../helpers/with-context"));

var _addFromLink = _interopRequireDefault(require("./add-from-link"));

var _flatten = _interopRequireDefault(require("lodash/flatten"));

var _Typography = _interopRequireDefault(require("@eig-builder/core-ui/Typography"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

require("./style/upload.scss");

require("../lang");

var _authUploadHelper = _interopRequireDefault(require("../helpers/auth-upload-helper"));

var _exifHelper = _interopRequireDefault(require("../helpers/exif-helper"));

var _imageLibraryHelper = require("../helpers/image-library-helper");

var _hooks = require("../hooks");

var _validateDroppedFiles = require("../helpers/validate-dropped-files");

var _notifications = require("../controls/notifications");

var _imageValidation = require("../helpers/image-validation");

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  fileHoverState: false,
  loading: false,
  showProgress: false
};

var UploadTab = function UploadTab(_ref) {
  var initialFiles = _ref.initialFiles,
      navigate = _ref.navigate,
      onUseImages = _ref.onUseImages,
      onUseImagesBase64 = _ref.onUseImagesBase64,
      tags = _ref.tags,
      setActionTop = _ref.setActionTop,
      isDragActive = _ref.isDragActive,
      extDisallowed = _ref.extDisallowed;

  var _React$useState = _react["default"].useState(initialState),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(false),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      loading = _React$useState4[0],
      setLoading = _React$useState4[1];

  var _React$useState5 = _react["default"].useState([]),
      _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
      files = _React$useState6[0],
      setFileState = _React$useState6[1];

  var _React$useState7 = _react["default"].useState([]),
      _React$useState8 = (0, _slicedToArray2["default"])(_React$useState7, 2),
      progressState = _React$useState8[0],
      setProgressState = _React$useState8[1];

  var _React$useState9 = _react["default"].useState([]),
      _React$useState10 = (0, _slicedToArray2["default"])(_React$useState9, 2),
      uploadState = _React$useState10[0],
      setUploadState = _React$useState10[1];

  var _React$useState11 = _react["default"].useState([]),
      _React$useState12 = (0, _slicedToArray2["default"])(_React$useState11, 2),
      erroredFiles = _React$useState12[0],
      setErroredFiles = _React$useState12[1];

  var _React$useState13 = _react["default"].useState(false),
      _React$useState14 = (0, _slicedToArray2["default"])(_React$useState13, 2),
      showProgress = _React$useState14[0],
      setShowProgress = _React$useState14[1];

  var _useActiveView = (0, _hooks.useActiveView)('upload'),
      active = _useActiveView.active;

  var inputRef = _react["default"].useRef(null);

  var _useNotifications = (0, _notifications.useNotifications)(),
      showNotification = _useNotifications.showNotification;

  var resetFilesStates = function resetFilesStates() {
    setProgressState([]);
    setUploadState([]);
    setErroredFiles([]);
    setFileState([]);
  };

  _react["default"].useEffect(function () {
    if (!active) {
      resetFilesStates();
    }
  }, [active]);

  _react["default"].useEffect(function () {
    showNotification({
      content: [/*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
        key: "notfication-msg",
        message: "imagepicker.drophovermessage",
        values: [(0, _runtimeConfigHelper.getRuntimeConfig)()._brandDisplayName]
      })],
      icon: /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: "keyboard_capslock"
      }),
      active: isDragActive,
      type: 'primary'
    });
  }, [isDragActive]);

  _react["default"].useEffect(function () {
    if (files && files.every(function (file) {
      return file.url;
    })) {
      setProgressState(files.map(function () {
        return 1;
      }));
      setUploadState(files.map(function () {
        return true;
      }));
    }
  }, [files]);

  _react["default"].useEffect(function () {
    if (!active) {
      setActionTop([]);
      setState(initialState);
    }

    return function () {
      setShowProgress(false);
    };
  }, []);

  var constructFileState = function constructFileState(files) {
    return {
      progressState: files.map(function (file) {
        return file.skip ? 1 : 0;
      }),
      uploadState: files.map(function (file) {
        return file.skip;
      })
    };
  }; // this needs that have errors properties


  var mapErrors = function mapErrors(files) {
    var errors = (0, _flatten["default"])(files.map(function (file) {
      return file.errors;
    }));
    var convertedErrors = (0, _imageValidation.validationErrorsToTextComponent)(errors);
    showNotification({
      content: convertedErrors,
      type: 'error',
      hideAfter: 9000
    });
  };

  var showGenericError = function showGenericError(errorConstant) {
    return showNotification({
      content: (0, _imageValidation.validationErrorsToTextComponent)(errorConstant),
      type: 'error'
    });
  };

  var doOrientationCheck = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(files) {
      var checkedOrientationPromises, filesWaited;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              checkedOrientationPromises = files.map( /*#__PURE__*/function () {
                var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(file) {
                  var exifData, fromBinary;
                  return _regenerator["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          exifData = new _exifHelper["default"](file.file);
                          _context.next = 3;
                          return exifData.readOrientationFromBinary();

                        case 3:
                          fromBinary = _context.sent;
                          return _context.abrupt("return", fromBinary);

                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }());
              _context2.next = 4;
              return Promise.all(checkedOrientationPromises);

            case 4:
              filesWaited = _context2.sent;
              return _context2.abrupt("return", filesWaited);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", _context2.t0);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    }));

    return function doOrientationCheck(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var addFiles = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(filesFromFunc) {
      var disallowedKeys, files, filesWaited, filesWaitedMapped, _erroredFiles, filesToUpload, _constructFileState, _progressState, _uploadState;

      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              disallowedKeys = extDisallowed && Object.keys(_config.FILE_EXT_MAPPING).filter(function (key) {
                return extDisallowed.indexOf(_config.FILE_EXT_MAPPING[key]);
              }).map(function (key) {
                return key;
              });
              files = (0, _validateDroppedFiles.validateDroppedFiles)(filesFromFunc, disallowedKeys && ['max_size', {
                name: 'ext',
                values: disallowedKeys
              }]);

              if (!(files.length === 0)) {
                _context3.next = 6;
                break;
              }

              resetFilesStates();
              _context3.next = 24;
              break;

            case 6:
              if (!(files.length === 1 && files.filter(function (file) {
                return file.skip;
              }).length === 1)) {
                _context3.next = 10;
                break;
              }

              mapErrors(files);
              _context3.next = 24;
              break;

            case 10:
              if (!(files.length > _config.MAX_AMOUNT_OF_FILES_UPLOADED_AT_ONCE)) {
                _context3.next = 14;
                break;
              }

              showGenericError([_config.TOO_MANY_FILES]);
              _context3.next = 24;
              break;

            case 14:
              setLoading(true);
              _context3.next = 17;
              return doOrientationCheck(files);

            case 17:
              filesWaited = _context3.sent;
              filesWaitedMapped = filesWaited.map(function (file, index) {
                return _objectSpread(_objectSpread({}, files[index]), {}, {
                  file: file
                });
              });
              _erroredFiles = filesWaitedMapped.filter(function (file) {
                return file.skip;
              });

              if (_erroredFiles.length > 0) {
                setErroredFiles(_erroredFiles);
              }

              filesToUpload = filesWaitedMapped.filter(function (file) {
                return !file.skip;
              });

              if (filesToUpload.length > 0) {
                _constructFileState = constructFileState(filesToUpload), _progressState = _constructFileState.progressState, _uploadState = _constructFileState.uploadState;
                setFileState(filesToUpload);
                setProgressState(_progressState);
                setUploadState(_uploadState);
              }

              setLoading(false);

            case 24:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function addFiles(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  var onError = function onError(e) {
    showGenericError([{
      path: 'imagepicker.uploadError',
      value: e.message
    }]);
    setShowProgress(false);
  };

  var onProgress = function onProgress(progress, index) {
    if (progress !== 1) {
      var newProgressState = (0, _toConsumableArray2["default"])(progressState);
      newProgressState[index] = (progress * 100).toFixed(0);
      setProgressState(newProgressState);
    } // when its done, we receive an object with file data


    if ((0, _typeof2["default"])(progress) === 'object') {
      var imageUrl = progress.callBackResponse.image_url;
      var newFiles = (0, _toConsumableArray2["default"])(files);
      newFiles[index].url = imageUrl;
      setFileState(newFiles);
    }
  };

  var goSignSomeUrls = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(filesPassed) {
      var filesLocal, token, storageEndpoint, filesToUpload, signedFileUpload;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              filesLocal = filesPassed || files;

              if (filesLocal.length === 1 && filesLocal.filter(function (file) {
                return file.error;
              }).length > 1) {
                mapErrors();
              }

              if (!(filesLocal.length > 0)) {
                _context4.next = 9;
                break;
              }

              setShowProgress(true);
              _context4.next = 6;
              return _authUploadHelper["default"].checkAuth();

            case 6:
              token = _context4.sent;
              storageEndpoint = (0, _storeServiceUrlHelper.getUrl)('base');

              if (storageEndpoint) {
                filesToUpload = filesLocal.map(function (file) {
                  return file.file;
                });
                signedFileUpload = new _signedUrlHelper["default"](filesToUpload, token, storageEndpoint, tags, onProgress, onError, {
                  multipleAtOnce: true
                });
                signedFileUpload.initialize(); // this triggers onProgress down the line
              } else {
                setShowProgress(false);
              }

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function goSignSomeUrls(_x4) {
      return _ref5.apply(this, arguments);
    };
  }();

  _react["default"].useEffect(function () {
    if (initialFiles.length > 0) {
      addFiles(initialFiles);
    }
  }, [initialFiles]);

  _react["default"].useEffect(function () {
    var hasFileProperty = files.some(function (file) {
      var _file$url;

      return (file === null || file === void 0 ? void 0 : (_file$url = file.url) === null || _file$url === void 0 ? void 0 : _file$url.length) > 0;
    });

    if (files.length > 0 && !hasFileProperty) {
      goSignSomeUrls(files);
    }
  }, [files]); // This is the flow from the "browse file"-flow


  var addMoreFiles = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(e) {
      var files;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              files = Array.from(e.target.files);
              e.target.value = '';
              addFiles(files);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function addMoreFiles(_x5) {
      return _ref6.apply(this, arguments);
    };
  }();

  var onChangeField = function onChangeField(e) {
    return addMoreFiles(e);
  }; // eslint-disable-line


  var openImageSelector = function openImageSelector() {
    return inputRef.current.click();
  }; // eslint-disable-line
  // should be a File type


  var addFromLink = function addFromLink(file) {
    return onUseImages(file);
  };

  var fileHoverState = state.fileHoverState;

  if (!active) {
    return null;
  }

  if (loading) {
    return /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
      centered: true,
      withPadding: true
    });
  }

  var className = (0, _classnames["default"])('ip-view', 'upload', {
    dropzone: files.length === 0 || files.filter(function (file) {
      return file.skip;
    }).length > 0,
    'file-overview': files.length > 0 && files.filter(function (file) {
      return file.skip;
    }).length === 0,
    mobile: (0, _imageLibraryHelper.isMobileMode)()
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, files.length === 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: fileHoverState ? 'file-hover active' : 'file-hover'
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "dropzone-spacer",
    onClick: openImageSelector
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "dropzone-content"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon-upload"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "cloud_upload",
    size: 90,
    color: "#cdcdcd"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon-text"
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.dragndrop"
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    tag: "browse-files-image-picker",
    color: "primary"
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.browsefiles"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "max-size-text"
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2"
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.maxSizeText1"
  }), " ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.maxSizeText2",
    values: [(0, _fileSizeHelper.bytesToFormattedString)(_config.MAX_FILE_SIZE)]
  }))), /*#__PURE__*/_react["default"].createElement("input", {
    ref: inputRef,
    type: "file",
    className: "hidden",
    multiple: true,
    onChange: onChangeField,
    onClick: function onClick(event) {
      event.target.value = null;
    }
  })))), /*#__PURE__*/_react["default"].createElement(_addFromLink["default"], {
    navigate: navigate,
    addImage: addFromLink
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "ip-view upload file-overview"
  }, /*#__PURE__*/_react["default"].createElement(_uploadProgress["default"], {
    progressStates: progressState,
    erroredFiles: erroredFiles,
    files: files,
    active: showProgress
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "files"
  }, files.length === 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: fileHoverState ? 'file-hover active' : 'file-hover'
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "progressive-file-loader"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "spacer"
  }, /*#__PURE__*/_react["default"].createElement(_imageCanvas["default"], {
    progressStates: progressState,
    files: files,
    onSelect: onUseImages,
    onSelectbase64: onUseImagesBase64,
    uploadStates: uploadState
  }))))));
};

UploadTab.propTypes = {
  initialFiles: _propTypes["default"].array,
  navigate: _propTypes["default"].func,
  onUseImages: _propTypes["default"].func,
  onUseImagesBase64: _propTypes["default"].func,
  tags: _propTypes["default"].object,
  setActionTop: _propTypes["default"].func.isRequired,
  isDragActive: _propTypes["default"].bool,
  extDisallowed: _propTypes["default"].array
};

var _default = (0, _withContext["default"])(UploadTab);

exports["default"] = _default;